import { useEffect, useState } from "react";
import { listenToAllOrders, deleteOrderFromFirestore, deleteProductFromOrderInFirestore, updateOrderNoteInFirestore } from "../../utils/functionFirebase";
import { Button, Form, Modal, Badge } from "react-bootstrap";
import { toast } from 'react-toastify';
import { doc, updateDoc, getDoc } from "firebase/firestore";
import { data } from "../../firebase/firebese";

export default function AdminCart() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterDate, setFilterDate] = useState("");
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [orderNotes, setOrderNotes] = useState({});
  const [showProductsModal, setShowProductsModal] = useState(false);
  const [modalProducts, setModalProducts] = useState([]);
  const [showAlert, setShowAlert] = useState(false);

  useEffect(() => {
    setLoading(true);
    const unsubscribe = listenToAllOrders((allOrders) => {
      setOrders(allOrders);
      setLoading(false);
    });
    
    // طلب إذن الإشعارات
    if (window.Notification && Notification.permission === "default") {
      Notification.requestPermission();
    }
    
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    let filtered = orders;
  
    if (filterDate) {
      filtered = filtered.filter(order => {
        const orderDate = new Date(order.date).toISOString().slice(0, 10);
        return orderDate === filterDate;
      });
    }
    // ترتيب تنازلي حسب التاريخ
    filtered = filtered.slice().sort((a, b) => new Date(b.date) - new Date(a.date));
    setFilteredOrders(filtered);
    
    // تنبيه عند وصول عدد الطلبات إلى 5 أو أكثر
    if (filtered.length >= 5 && !showAlert) {
      setShowAlert(true);
      toast.warning(`⚠️ تنبيه: عدد الطلبات المعلقة ${filtered.length}! يرجى معالجتها بسرعة.`);
      
      // إشعار صوتي (اختياري)
      if (window.Notification && Notification.permission === "granted") {
        new Notification("تنبيه الطلبات", {
          body: `عدد الطلبات المعلقة: ${filtered.length}`,
          icon: "/logo.png"
        });
      }
    } else if (filtered.length < 5 && showAlert) {
      setShowAlert(false);
    }
  }, [orders, filterDate, showAlert]);

  // دالة لتحديد لون البادج حسب حالة الطلب
  const getStatusBadge = (status) => {
    switch (status) {
      case "تم الإنجاز":
        return <Badge bg="success" className="mx-1">تم الإنجاز</Badge>;
      case "جاري التجهيز":
        return <Badge bg="warning" className="mx-1">جاري التجهيز</Badge>;
      case "تم الطلب":
        return <Badge bg="info" className="mx-1">تم الطلب</Badge>;
      case "تم التسليم":
        return <Badge bg="primary" className="mx-1">تم التسليم</Badge>;
      default:
        return <Badge bg="secondary" className="mx-1">{status || "جديد"}</Badge>;
    }
  };

  // دالة لتحديث حالة الطلب
  const handleUpdateOrderStatus = async (order, newStatus) => {
    try {
      // تحديث حالة الطلب في جدول الطلبات
      await updateOrderNoteInFirestore(order, order.adminNote || "", newStatus);
      
      // تحديث حالة الطلب في ملف المستخدم
      if (order.userId) {
        const userDoc = await getDoc(doc(data, "authentact", order.userId));
        if (userDoc.exists()) {
          const userData = userDoc.data();
          const actions = userData.actions || [];
          
          // البحث عن الطلب وتحديث حالته
          const updatedActions = actions.map(action => {
            if (action.type === "order" && 
                action.date === order.date && 
                action.tableNumber === order.tableNumber) {
              return { ...action, status: newStatus };
            }
            return action;
          });
          
          await updateDoc(doc(data, "authentact", order.userId), {
            actions: updatedActions
          });
        }
      }
      
      toast.success(`تم إنجاز الطلب بنجاح! سيتم إخفاؤه من القائمة.`);
    } catch (error) {
      console.error("خطأ في تحديث حالة الطلب:", error);
      toast.error("حدث خطأ في تحديث حالة الطلب!");
    }
  };

  const handleDeleteOrder = async (idx) => {
    if (window.confirm("هل أنت متأكد من حذف هذا الطلب؟")) {
      const order = filteredOrders[idx];
      await deleteOrderFromFirestore(order);
      toast.success("تم حذف الطلب من قاعدة البيانات!");
    }
  };

  const handleDeleteProduct = async (orderIdx, productIdx) => {
    const order = filteredOrders[orderIdx];
    await deleteProductFromOrderInFirestore(order, productIdx);
    toast.success("تم حذف المنتج من الطلب!");
  };

  // دالة لطباعة الطلب كفاتورة
  const handlePrintOrder = (order) => {
    const win = window.open('', 'PRINT', 'height=600,width=400');
    win.document.write(`
      <html dir="rtl"><head>
        <title>فاتورة الطلب</title>
        <style>
          body { font-family: Tahoma, Arial, sans-serif; padding: 20px; }
          h2 { text-align: center; margin-bottom: 16px; }
          table { width: 100%; border-collapse: collapse; margin-bottom: 12px; }
          th, td { border: 1px solid #ccc; padding: 6px 8px; text-align: center; font-size: 15px; }
          th { background: #f5f5f5; }
          .total { font-weight: bold; font-size: 17px; }
          .footer { text-align: center; margin-top: 18px; font-size: 13px; color: #888; }
          .no-print { display: none !important; }
          @media print {
            .no-print { display: none !important; }
          }
        </style>
      </head><body>
        <h2>فاتورة الطلب</h2>
        <div><b>رقم الطاولة:</b> ${order.tableNumber || '-'}</div>
        <div><b>الاسم:</b> ${order.name || order.userName || '-'}</div>
        <div><b>رقم الهاتف:</b> ${order.phone || '-'}</div>
        <div><b>التاريخ:</b> ${order.date ? new Date(order.date).toLocaleString('ar-EG') : '-'}</div>
        <div><b>الحالة:</b> ${order.status || 'جديد'}</div>
        <hr/>
        <table>
          <thead>
            <tr><th>المنتج</th><th>الكمية</th><th>السعر</th><th>الإجمالي</th></tr>
          </thead>
          <tbody>
            ${(order.items || []).map(item => `
              <tr>
                <td>${item.name}</td>
                <td>${item.quantity}</td>
                <td>${item.price}</td>
                <td>${item.price * item.quantity}</td>
              </tr>
            `).join('')}
          </tbody>
        </table>
        <div class="total">المجموع الكلي: ${order.total} د.أ</div>
        ${order.adminNote ? `<div><b>ملاحظة:</b> ${order.adminNote}</div>` : ''}
        <div class="footer">شكراً لزيارتكم</div>
      </body></html>
    `);
    win.document.close();
    win.focus();
    setTimeout(() => { win.print(); win.close(); }, 500);
  };

  const handleSaveOrderNote = async (order, noteValue) => {
    await updateOrderNoteInFirestore(order, noteValue, null);
    setOrderNotes(prev => {
      const newNotes = { ...prev };
      delete newNotes[order.id];
      return newNotes;
    });
    toast.success("تم حفظ الملاحظة!");
  };

  const handleShowProducts = (items) => {
    setModalProducts(items || []);
    setShowProductsModal(true);
  };
  const handleCloseProducts = () => setShowProductsModal(false);

  return (
    <div className="container py-5">
      <h2 className="mb-4 text-center">لوحة تحكم الأدمن</h2>
      
      {/* تنبيه عدد الطلبات */}
      {showAlert && (
        <div className="alert alert-warning alert-dismissible fade show" role="alert">
          <strong>⚠️ تنبيه مهم!</strong> عدد الطلبات المعلقة: <strong>{filteredOrders.length}</strong>
          <br />
          يرجى معالجة الطلبات بسرعة لتجنب التأخير في الخدمة.
          <button 
            type="button" 
            className="btn-close" 
            onClick={() => setShowAlert(false)}
            aria-label="Close"
          ></button>
        </div>
      )}
      <div className="mb-3 d-flex gap-2 flex-wrap align-items-center justify-content-between">
        <div className="d-flex gap-2 flex-wrap align-items-center">
          <Form.Control
            type="date"
            value={filterDate}
            onChange={e => setFilterDate(e.target.value)}
            style={{ maxWidth: 180 }}
          />
          <Button variant="secondary" onClick={() => setLoading(true)}>تحديث</Button>
        </div>
        
        {/* عداد الطلبات */}
        <div className="d-flex align-items-center gap-2">
          <span className="badge bg-primary fs-6">
            عدد الطلبات: {filteredOrders.length}
          </span>
          {filteredOrders.length >= 5 && (
            <span className="badge bg-danger fs-6">
              ⚠️ طلبات كثيرة!
            </span>
          )}
        </div>
      </div>
      {loading ? (
        <div className="text-center">جاري التحميل...</div>
      ) : filteredOrders.length === 0 ? (
        <div className="text-center">لا يوجد طلبات بعد.</div>
      ) : (
        <div className="table-responsive">
          <table className="table table-bordered table-striped text-center">
            <thead>
              <tr>
                <th>ID</th>
                <th>رقم الطاولة</th>
                <th>تاريخ الطلب</th>
                <th>عدد المنتجات</th>
                <th>المجموع</th>
                <th>إنجاز الطلب</th>
                <th>تفاصيل المنتجات</th>
                <th>بيانات إضافية</th>
                <th>إجراءات</th>
              </tr>
            </thead>
            <tbody>
              {filteredOrders.map((order) => (
                <tr key={order.id} style={{ 
                  background: order.status === "تم الإنجاز" ? '#e8f5e8' : 
                             order.status === "جاري التجهيز" ? '#fff3cd' : 
                             order.items?.length === 0 ? '#ffeaea' : undefined 
                }}>
                  <td>{filteredOrders.indexOf(order)}</td>
                  <td style={{fontWeight:'bold', color:'#007bff'}}>{order.tableNumber || '-'}</td>
                  <td>{new Date(order.date).toLocaleString("ar-EG")}</td>
                  <td>{order.items?.length || 0}</td>
                  <td>{order.total} د.أ</td>
                  <td>
                    {getStatusBadge(order.status)}
                    <div className="mt-2">
                      <Button 
                        variant="success" 
                        size="sm" 
                        className="me-1"
                        onClick={() => handleUpdateOrderStatus(order, "تم الإنجاز")}
                        disabled={order.status === "تم الإنجاز"}
                        style={{ 
                          opacity: order.status === "تم الإنجاز" ? 0.6 : 1,
                          fontWeight: order.status === "تم الإنجاز" ? "bold" : "normal"
                        }}
                      >
                        ✅ تم الإنجاز
                      </Button>
                    </div>
                  </td>
                  <td>
                    <Button variant="outline-primary" size="sm" onClick={() => handleShowProducts(order.items)}>
                      عرض تفاصيل المنتجات
                    </Button>
                  </td>
                  <td style={{fontSize:12, direction:'rtl'}}>
                    <div style={{display:'flex', alignItems:'center', gap:4}}>
                      <input
                        type="text"
                        value={
                          orderNotes.hasOwnProperty(order.id)
                            ? orderNotes[order.id]
                            : (order.adminNote ?? "")
                        }
                        placeholder="أدخل ملاحظة على الطلب"
                        onFocus={() => {
                          if (!orderNotes.hasOwnProperty(order.id)) {
                            setOrderNotes(prev => ({
                              ...prev,
                              [order.id]: order.adminNote ?? ""
                            }));
                          }
                        }}
                        onChange={e =>
                          setOrderNotes(prev => ({
                            ...prev,
                            [order.id]: e.target.value
                          }))
                        }
                        style={{margin:'4px 0', fontSize:12, flex:1}}
                      />
                      <Button
                        size="sm"
                        variant="success"
                        onClick={() => handleSaveOrderNote(order, orderNotes[order.id] ?? "")}
                        style={{fontSize:11, height:28}}
                      >
                        حفظ
                      </Button>
                    </div>
                  </td>
                  <td>
                    <div style={{display:'flex', flexDirection:'row', gap:8, justifyContent:'center'}} className="no-print">
                      <Button 
                        variant="danger" 
                        size="sm" 
                        style={{transition:'none', boxShadow:'none', transform:'none'}}
                        onClick={() => handleDeleteOrder(filteredOrders.findIndex(o => o.id === order.id))}>
                        حذف الطلب
                      </Button>
                      <Button 
                        variant="info" 
                        size="sm" 
                        style={{transition:'none', boxShadow:'none', transform:'none'}}
                        onClick={() => handlePrintOrder(order)}>
                        طباعة
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <Modal show={showProductsModal} onHide={handleCloseProducts} centered backdrop="static" style={{backdropFilter:'blur(4px)'}}>
        <Modal.Header closeButton>
          <Modal.Title>تفاصيل المنتجات</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ul className="order-items-list">
            {modalProducts.map((item, i) => (
              <li key={i} className="order-item-li">
                <div>
                  {item.name} × {item.quantity} ({item.price} د.أ)
                  {item.note && (
                    <div style={{ color: "#B45B35", fontSize: 12 }}>
                      ملاحظة: {item.note}
                    </div>
                  )}
                </div>
                <Button
                  variant="outline-danger"
                  size="sm"
                  className="delete-product-btn"
                  onClick={() => {
                    // ابحث عن الطلب الأصلي في filteredOrders
                    const orderIdx = filteredOrders.findIndex(o => o.items === modalProducts);
                    handleDeleteProduct(orderIdx, i);
                  }}
                >حذف المنتج</Button>
              </li>
            ))}
          </ul>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseProducts}>إغلاق</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}